export default () => {
  if (window.screen.width > 1200) {
    document.querySelector('.nav__catalog').addEventListener('mouseenter', () => {
      document.querySelector('.header').classList.add('active')
      document.querySelector('.header').classList.remove('header--search')
    })
    document.querySelector('.nav__catalog').addEventListener('mouseleave', () => {
      document.querySelector('.header').classList.remove('active')
    })
  } else {
    document.querySelector('.js-products-btn').addEventListener('click', (e) => {
      e.preventDefault()
      document.querySelector('.header').classList.add('active')
    })
    document.querySelector('.nav__catalog-back').addEventListener('click', () => {
      document.querySelector('.header').classList.remove('active')
    })
  }
  const dropItem = document.querySelectorAll('.nav__catalog-box a')
  function getAllSiblings(element, parent) {
    const children = [...parent.children];
    return children.filter(child => child !== element);
  }
  dropItem.forEach(function (el, i) {
    const id = el.getAttribute('data-id')
    const elSiblings = getAllSiblings(el.closest('li'), el.closest('.nav__catalog-list'))
    el.addEventListener('mouseenter', () => {
      elSiblings.forEach(element => element.classList.remove('active'))
      if (el.closest('.js-level').nextElementSibling) {
        el.closest('.js-level').nextElementSibling.querySelectorAll('ul').forEach(element => element.classList.remove('active'))
      }
      $(el).closest('.js-level').nextAll('.js-level').removeClass('active')
      el.closest('li').classList.add('active')
      if (el.closest('li').classList.contains('nav__catalog-drop')) {
        el.closest('.js-level').nextElementSibling.classList.add('active')
        el.closest('.js-level').nextElementSibling.querySelectorAll('ul').forEach(element => element.classList.remove('active'))
        el.closest('.js-level').nextElementSibling.querySelector(`ul[data-id="${id}"]`).classList.add('active')
      }
    })
  })
  document.querySelector('.nav__catalog-box').addEventListener('mouseleave', () => {
    document.querySelectorAll('.js-level').forEach(el => el.classList.remove('active'))
    document.querySelectorAll('.nav__catalog-box ul').forEach(el => el.classList.remove('active'))
    document.querySelectorAll('.nav__catalog-box li').forEach(el => el.classList.remove('active'))
  })
}


// WEBPACK FOOTER //
// app/scripts/components/header-catalog.js